import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { AuthTokenService } from 'src/app/services/auth-token.service';
import { AccountAuthService } from '../account-auth.service';
import { newPasswordForm } from '../new-password-form';

/** Profile page: change password (signs out other devices; this one stays signed in). */
@Component({
  selector: 'app-change-password-card',
  templateUrl: './change-password-card.component.html',
  styleUrls: ['../auth-form.scss', './change-password-card.component.scss'],
  standalone: false,
})
export class ChangePasswordCardComponent {
  open = false;
  busy = false;
  done = false;
  error: string | null = null;
  currentError: string | null = null;
  passwordError: string | null = null;

  readonly current = this.fb.control('', Validators.required);
  readonly form = newPasswordForm(this.fb);

  constructor(
    private fb: FormBuilder,
    private auth: AccountAuthService,
    private tokens: AuthTokenService,
    private cdr: ChangeDetectorRef,
  ) {
    this.current.valueChanges.subscribe(() => (this.currentError = null));
    this.form.controls.password.valueChanges.subscribe(() => (this.passwordError = null));
  }

  start(): void {
    this.open = true;
    this.done = false;
  }

  cancel(): void {
    this.open = false;
    this.reset();
  }

  private reset(): void {
    this.current.reset('');
    this.form.reset({ password: '', confirm: '' });
    this.error = this.currentError = this.passwordError = null;
  }

  submit(): void {
    if (this.busy) return;
    if (this.current.invalid || this.form.invalid) {
      this.current.markAsTouched();
      this.form.markAllAsTouched();
      return;
    }
    if (this.current.value === this.form.controls.password.value) {
      this.passwordError = 'Choose a different password from your current one.';
      return;
    }
    this.busy = true;
    this.error = null;
    this.auth.changePassword(this.current.value!, this.form.controls.password.value!).subscribe({
      next: (session) => {
        // The old tokens no longer work; carry on with the new pair.
        this.tokens.setTokens(session.accesstoken, session.refreshtoken);
        this.busy = false;
        this.open = false;
        this.done = true;
        this.reset();
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.busy = false;
        const error = this.auth.toError(err);
        if (error.code === 'wrong_password') this.currentError = error.message;
        else if (error.code === 'weak_password') this.passwordError = error.message;
        else this.error = error.message;
        this.cdr.detectChanges();
      },
    });
  }
}
